<template>
  <div class="app">
    <div class="bor"></div>
    <div class="tishi">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'Promptbox',
  data() {
    return {
      text: '',
    }
  },
  props: ['message'],
  mounted() {
    console.log(this.message)
    this.text = this.message
    // switch (this.message) {
    //   case 1:
    //     this.text = '此卡已绑定，不可重复绑定'
    //     break
    //   case 2:
    //     this.text = '卡号、姓名与电话不一致'
    //     break
    //   case 3:
    //     this.text = '绑定失败'
    //     break
    //   case 4:
    //     this.text = '绑定成功'
    //     break
    //   case 5:
    //     this.text = '解除绑定失败'
    //     break
    //   case 6:
    //     this.text = '解除绑定成功'
    //     break
    //   case 7:
    //     this.text = '请输入兑换积分'
    //     break
    //   case 8:
    //     this.text = '可用积分不足'
    //     break
    //   case 9:
    //     this.text = '请仔细查看兑换比例'
    //     break
    //   case 10:
    //     this.text = '请输入兑换积分的整倍数'
    //     break
    //   case 11:
    //     this.text = '网络链接异常'
    //     break
    //   case 12:
    //     this.text = '获取验证码失败'
    //     break
    //   case 13:
    //     this.text = '验证码无效'
    //     break
    //   case 14:
    //     this.text = '发送短信失败请联系商家'
    //     break
    //   case 15:
    //     this.text = '请输入正确的手机号'
    //     break
    //   case 16:
    //     this.text = '兑换成功'
    //     break
    //   case 17:
    //     this.text = '设置成功'
    //     break
    // }
  },
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.app {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0);
}
.bor {
  width: 140px;
  height: 30px;
  border-radius: 3px;
  background: #000;
  position: fixed;
  top: 50%;
  left: 50%;
  opacity: 0.7;
  margin-left: -70px;
  margin-top: -15px;
  z-index: 99;
}
.tishi {
  width: 140px;
  height: 30px;
  border-radius: 3px;
  color: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -70px;
  margin-top: -15px;
  z-index: 9999999;
  font-size: 10px;
  text-align: center;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Promptbox.vue